if (!customElements.get('planted-video')) {
  class PlantedVideo extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video')
      const controls = video.getAttribute('controls')
      const icon = this.querySelector('[data-play-icon]')
      this.addEventListener('click', function (event) {
        event.preventDefault()
        if (video.paused == true) {
          video.play()
          icon.classList.add('opacity-0')
          if (!!controls) {
            icon.classList.add('pointer-events-none')
          }
        } else {
          video.pause()
          icon.classList.remove('opacity-0')
          icon.classList.remove('pointer-events-none')
        }
      })
    }
  }
  customElements.define('planted-video', PlantedVideo)
}
